import React from 'react';
import { ButtonContainer } from './ArrowButtons.styles';

interface ArrowButtonProps {
  ariaLabel?: string;
  onChange: () => void;
  buttonType: 'prev' | 'next';
  // eslint-disable-next-line react/no-unused-prop-types
  children?: React.ReactNode;
}

const ArrowButton: React.FC<ArrowButtonProps> = ({ onChange, buttonType, ariaLabel }) => {
  const ArrowRight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.49938 17.439L14.9844 11.996L9.50438 6.56104" stroke="black" />
    </svg>
  );
  const ArrowLeft = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5006 6.56097L9.01563 12.004L14.4956 17.439" stroke="black" />
    </svg>
  );

  return (
    <ButtonContainer
      aria-label={ariaLabel || ''}
      onClick={onChange}
      data-testid={`${buttonType}-slide`}
    >
      {buttonType === 'next' ? ArrowRight : ArrowLeft}
    </ButtonContainer>
  );
};

export default ArrowButton;
